export enum UserRoles {
  admin = 'admin',
}
